import { isAxiosError, isCancel } from 'axios';

const SERVER_UNAVAILABLE_STATUSES = [502, 503, 504];

// True when a failed request most likely means the API itself is unreachable
// (prod deploy in progress, ALB with no healthy targets). A down server behind
// the ALB answers without CORS headers, so the browser blocks the response and
// axios sees a network error with no `response` — that case lands here too.
export function isServerUnavailableError(error: unknown): boolean {
    if (isCancel(error) || !isAxiosError(error)) {
        return false;
    }
    if (error.config?.skipMaintenanceCheck) {
        return false;
    }
    if (error.response) {
        return SERVER_UNAVAILABLE_STATUSES.includes(error.response.status);
    }
    // No response at all: server down or CORS-blocked gateway error — unless
    // it's the user's own connection that is offline.
    return navigator.onLine !== false;
}
